import { render, staticRenderFns } from "./NewEvent.vue?vue&type=template&id=9c3f0f08&"
import script from "./NewEvent.vue?vue&type=script&lang=js&"
export * from "./NewEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports